import axios from 'axios';

export const createEnterprise = async (formData) => {
    return axios.post('/enterprises', formData);
};

export const updateEnterprise = async (formData, uuid) => {
    return axios.put(`/enterprises/${uuid}`, formData);
};

export const fetchEnterprises = async (pagination, searchName = null) => {
    return await axios.get('/enterprises', {
        params: {
            page: pagination ? pagination.currentPage : 1,
            pageLimit: pagination ? pagination.itemsPerPage : 10,
            ...(searchName && { searchName })
        },
    });
};

export const fetchEnterprisesIdAndNames = async () => {
    return await axios.get('/enterprises/short-list');
};

export const fetchEnterpriseSettingsByEnterpriseUuid = async (enterpriseUuid, publicSettings = false) => {
    return await axios.get(publicSettings ? '/public-settings' : '/private-settings', {
        params: {
            enterpriseUuid
        }
    });
};

export const fetchDefaultSettings = async () => {
    return await axios.get('/default-settings');
};

export const fetchScopeSettings = async () => {
    return await axios.get('/scope-settings');
};